import { render, staticRenderFns } from "./CardTabs.vue?vue&type=template&id=46648bba&scoped=true&"
import script from "./CardTabs.vue?vue&type=script&lang=js&"
export * from "./CardTabs.vue?vue&type=script&lang=js&"
import style0 from "./CardTabs.vue?vue&type=style&index=0&id=46648bba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46648bba",
  null
  
)

export default component.exports